import React from "react";

import PropTypes from "prop-types";
import GBStdTable from "../../../Library/Tables/GBStdTableAG/GbStdTable";
import { DMService } from "../../../API/server_calls";
import { clone } from "../../GB/NonComponents/GBUtil";

class DMCoverageForm extends React.Component {
    static propTypes = {
        DM: PropTypes.object,
        handleCovTargBySNU: PropTypes.func,
    };

    static defaultProps = {
        covTable: {},
        setCovTable: () => console.log("setCovTable"),
        createTable: () => console.log("createTable"),
    };

    constructor(props) {
        super(props);

        this.state = {
            DM: JSON.parse(JSON.stringify(this.props.DM)),
            pastedVal: null,
        };
    }

    /*state = {
	  covTable: {}
	}*/

    componentDidMount() {
        //row headers
        if (this.state.DM.targCoverageBySNU.coverages === null) {
            DMService.getTargCoverage(
                this.props.selectedCountryMstID,
                (response) => {
                    const DM = this.state.DM;
                    const names = JSON.parse(response).coverageRowNames;
                    const coverages = JSON.parse(response).defaultCoverage;

                    //console.log(coverages);
                    this.props.createTable(coverages, names);
                    this.props.handleTargBySNU(coverages, names);
                },
                () => {}
            );
        } else {
            const DM = this.state.DM;
            const coverages = JSON.parse(JSON.stringify(DM.targCoverageBySNU.coverages));
            const names = JSON.parse(JSON.stringify(DM.targCoverageBySNU.names));

            this.props.createTable(coverages, names);
            this.props.handleTargBySNU(coverages, names);
        }
    }

    onPacktableChanged = (tb) => {
        //console.log(1);
        let coverages = JSON.parse(JSON.stringify(this.props.DM.targCoverageBySNU.coverages));
        let names = JSON.parse(JSON.stringify(this.props.DM.targCoverageBySNU.names));

        //console.log((tb.tableData.value).length);
        console.log(tb.tableData.value);
        for (let r = 1; r < tb.tableData.value.length; r++) {
            //console.log("Row "+r);
            //console.log("Row "+r+" Col "+c);
            //console.log(tb.tableData.value[r][c]);
            for (let c = 1; c < tb.tableData.value[r].length; c++) {
                if (tb.tableData.value[r][c] !== "") {
                    coverages[r - 1][c + 1] = tb.tableData.value[r][c];
                }
            }
            if (coverages[r - 1].length > 3) {
                //console.log(coverages[r-1][2]);
                coverages[r - 1][1] = coverages[r - 1][2]; //EIMC is 0-4 and 5-10
            }
        }
        //console.log(3);

        // console.log(coverages);
        this.props.handleTargBySNU(coverages, names);
        this.props.setCovTable(tb);
    };

    onPasteStart = (props, state) => (event) => {
        const range = event.api.getCellRanges()[0];
        if (range) {
            let coverages = clone(props.DM.targCoverageBySNU.coverages);
            let names = clone(props.DM.targCoverageBySNU.names);

            let covTable = clone(props.covTable);

            const firstRowIndex = range.startRow.rowIndex;
            const finalRowIndex = range.endRow.rowIndex;

            // Retrieve all visible columns in order
            const allColumns = event.columnApi.getAllDisplayedColumns();

            // Get start and end column objects
            const startColumn = range.columns[0];
            const endColumn = range.columns[range.columns.length - 1];

            // Find numeric indices for start and end columns
            const firstColIndex = allColumns.indexOf(startColumn);
            const finalColIndex = allColumns.indexOf(endColumn);

            // Access the pasted value from the state
            const pastedValue = state.pastedVal;

            if (pastedValue !== undefined) {
                // Iterate over the range and apply the pasted value
                for (let rowIndex = firstRowIndex; rowIndex <= finalRowIndex; rowIndex++) {
                    for (let colIndex = firstColIndex; colIndex <= finalColIndex; colIndex++) {
                        coverages[rowIndex][colIndex + 1] = pastedValue;
                        covTable.tableData.value[rowIndex + 1][colIndex] = pastedValue;
                    }
                }
                props.handleTargBySNU(coverages, names);
                props.setCovTable(covTable);
            }
        }
    };

    processCellFromClipboard = (state) => (params) => {
        state.pastedVal = parseInt(params.value); // Capture the value being pasted and store it in state
        return params.value; // Allow the value to pass through
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    render() {
        try {
            const styles = {
                start_page: {
                    padding: "10px",
                },

                col: {
                    width: "32%",
                    display: "inline-block",
                },

                indent: 40,
            };

            return (
                <div style={styles.start_page}>
                    <GBStdTable
                        packTable={this.props.covTable}
                        onPackTableChanged={this.onPacktableChanged}
                        onPasteStart={this.onPasteStart(this.props, this.state)}
                        processCellFromClipboard={this.processCellFromClipboard(this.state)}
                    />
                </div>
            );
        } catch (exception) {
            return (
                <div
                    className={"DMWelcomeFormDiv"}
                    key={"DMWelcomeFormDiv"}
                >
                    <h3 key={"DMWelcomeFormDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default DMCoverageForm;
